import { Attachment } from '@/modules/Upload/types'
import { isAttachment } from '@/utils/function'

export const onDelete = ({
    attachments,
    file,
}: {
    attachments: File[] | Attachment[]
    file: File | Attachment
}) => {
    let newAttachments: File[] | Attachment[] = []

    const isFile = file instanceof File
    if (isFile) {
        newAttachments = attachments?.filter((attachment) => {
            if (attachment instanceof File) {
                return attachment.name !== file.name
            }
            return true
        }) as File[]
    }
    if (isAttachment(file)) {
        newAttachments = attachments?.filter((attachment) => {
            if (attachment instanceof File) {
                return true
            }
            return (
                attachment.attachment_id !== (file as Attachment).attachment_id
            )
        }) as Attachment[]
    }
    return newAttachments
}

export const onUpload = async ({
    oldAttachments,
    attachments,
    uploadAsync,
}: {
    oldAttachments: Attachment[]
    attachments: File[] | Attachment[]
    uploadAsync: (
        files: File[]
    ) => Promise<{ status: string; value: Attachment }[]>
}) => {
    let newAttachments: Attachment[] = []
    let attachments_to_delete: number[] = []
    if (attachments && attachments?.length > 0) {
        const attFiles = attachments?.filter(
            (attachment) => attachment instanceof File
        ) as File[]
        const atts = attachments?.filter((attachment) =>
            isAttachment(attachment)
        ) as Attachment[]
        const attIDs = atts?.map(
            (attachment) => attachment.attachment_id
        ) as number[]

        attachments_to_delete = oldAttachments
            ?.filter(
                (attachment) =>
                    !attIDs.includes((attachment as Attachment).attachment_id)
            )
            ?.map(
                (attachment) => (attachment as Attachment).attachment_id
            ) as number[]
        const attachmentUploadeds = await uploadAsync(attFiles)

        newAttachments = attachmentUploadeds
            ?.filter((attachment) => attachment.status === 'fulfilled')
            .map((attachment) => attachment.value) as Attachment[]
    }
    return {
        attachments: newAttachments,
        attachments_to_delete,
    }
}
